// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import {
  TestDatasetParameter,
  TestDatasetParameterFromJSON,
  TestDatasetParameterToJSON,
  UserMinified,
  UserMinifiedFromJSON,
  UserMinifiedToJSON,
} from "./";

/**
 *
 * @export
 * @interface TestDataset
 */
export interface TestDataset {
  /**
   *
   * @type {number}
   * @memberof TestDataset
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof TestDataset
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof TestDataset
   */
  description?: string;
  /**
   *
   * @type {Array<TestDatasetParameter>}
   * @memberof TestDataset
   */
  parameters: Array<TestDatasetParameter>;
  /**
   * JSON stringified
   * @type {string}
   * @memberof TestDataset
   */
  datarows: string;
  /**
   *
   * @type {string}
   * @memberof TestDataset
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof TestDataset
   */
  updatedAt?: string;
  /**
   *
   * @type {UserMinified}
   * @memberof TestDataset
   */
  createdBy?: UserMinified;
  /**
   *
   * @type {number}
   * @memberof TestDataset
   */
  archived?: number;
  /**
   * True when a BDD sync (`tc sync`) made the dataset from the `Examples:` tables of a Scenario Outline in a `.feature` file in Git. The repository owns it, so it cannot be changed or deleted by hand (`PUT` and `DELETE` answer 422); only `tc sync` changes it. Each of its data rows also holds `bdd_example_index`, the Examples row as Cucumber numbers it in a report (`<table>.<row>`, for example \"2.1\"), and `bdd_example_name`, the name of its Examples table. They are not parameters.
   * @type {boolean}
   * @memberof TestDataset
   */
  readonly isBddManaged?: boolean;
}

export function TestDatasetFromJSON(json: any): TestDataset {
  return {
    id: json["id"],
    name: json["name"],
    description: !exists(json, "description") ? undefined : json["description"],
    parameters: (json["parameters"] as Array<any>).map(
      TestDatasetParameterFromJSON
    ),
    datarows: json["datarows"],
    createdAt: !exists(json, "created_at") ? undefined : json["created_at"],
    updatedAt: !exists(json, "updated_at") ? undefined : json["updated_at"],
    createdBy: !exists(json, "created_by")
      ? undefined
      : UserMinifiedFromJSON(json["created_by"]),
    archived: !exists(json, "archived") ? undefined : json["archived"],
    isBddManaged: !exists(json, "is_bdd_managed")
      ? undefined
      : json["is_bdd_managed"],
  };
}

export function TestDatasetToJSON(value?: TestDataset): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    id: value.id,
    name: value.name,
    description: value.description,
    parameters: (value.parameters as Array<any>).map(
      TestDatasetParameterToJSON
    ),
    datarows: value.datarows,
    created_at: value.createdAt,
    updated_at: value.updatedAt,
    created_by: UserMinifiedToJSON(value.createdBy),
    archived: value.archived,
  };
}
